// extracted by mini-css-extract-plugin
export default {"container":"create_assessment_container__Lh6dL","modalDimensions":"create_assessment_modalDimensions__XzhAU"};